<template>
  <div>
    <modal-template
      v-show="toggle"
      @close="toggleInfoModal"
      class="override-modal"
    >
      <template #header>
        <i class="icon-ic_close" @click="toggleInfoModal" />
        <h3>{{ $t('agenda.justificar-ausencia.titulo') }}</h3>
      </template>
      <template #body>
        <div v-if="dentroDoPrazo">
          <!--
<b-notification
            v-if="exibirAvisoFeriasColetivas"
            type="is-warning"
            :closable="false"
          >
            {{ $t('agenda.justificar-ausencia.avisoFeriasColetivas') }}
          </b-notification>
-->
          <template v-if="!isSoCancelavel()">
            <h2 class="explicacao-motivo">
              {{ $t('agenda.justificar-ausencia.explicacaoMotivo1') }}<br />
              {{ $t('agenda.justificar-ausencia.explicacaoMotivo2') }}
            </h2>
            <br />
            <div class="radios-justificativa">
              <b-field v-if="isAtendimentoProximo() && !isTeleatendimento">
                <b-radio
                  v-model="motivo"
                  name="motivo"
                  native-value="1"
                  :disabled="isSoCancelavel()"
                  @input="data = undefined"
                >
                  {{ $t('agenda.justificar-ausencia.motivo1') }}
                </b-radio>
              </b-field>
              <b-field>
                <b-radio
                  v-model="motivo"
                  name="motivo"
                  native-value="3"
                  :disabled="isSoCancelavel()"
                  @input="data = undefined"
                >
                  {{
                    isTeleatendimento
                      ? $t('agenda.justificar-ausencia.motivo3Teleatendimento')
                      : $t('agenda.justificar-ausencia.motivo3')
                  }}
                </b-radio>
              </b-field>
              <b-field>
                <b-radio
                  v-model="motivo"
                  name="motivo"
                  native-value="4"
                  @input="data = undefined"
                >
                  {{ $t('agenda.justificar-ausencia.motivo4') }}
                </b-radio>
              </b-field>
            </div>
          </template>
          <div v-if="motivo == 4">
            <b-field :label="$t('agenda.justificar-ausencia.perguntaMotivo4')">
              <b-input type="textarea" v-model="motivoCancelamento" />
            </b-field>
            <b-notification type="is-warning" :closable="false">
              {{
                $props.atendimentos.length > 1
                  ? $t('agenda.justificar-ausencia.avisoMotivo4Plural')
                  : $t('agenda.justificar-ausencia.avisoMotivo4Singular')
              }}
            </b-notification>
          </div>
          <div v-else-if="motivo">
            <b-field
              class="date-justificativa"
              :label="
                isTeleatendimento
                  ? $t(
                    'agenda.justificar-ausencia.perguntaPrazoTeleatendimento'
                  )
                  : $t('agenda.justificar-ausencia.perguntaPrazo' + motivo)
              "
              placeholder="##/##/####"
            >
              <b-datepicker
                v-model="data"
                editable
                class="date-picker-absolute"
                locale="pt-BR"
                :date-formatter="dateFormatter"
                :date-parser="dateParser"
                :day-names="dayNames"
                :month-names="monthNames"
              />
            </b-field>
            <span v-if="data && !validar()">
              <b-notification type="is-warning" :closable="false">
                Escolha uma data entre {{ format(getDataMinima()) }} e
                {{ format(getDataMaxima()) }}.
              </b-notification>
            </span>
          </div>
          <div v-if="motivo != 4 && !isSoCancelavel() && !isTeleatendimento">
            <br />
            <b-checkbox
              v-model="converterTeleatendimento"
              class="conversao-teleatendimento"
            >
              {{ $t('agenda.justificar-ausencia.conversaoTeleatendimento') }}
            </b-checkbox>
          </div>
        </div>
        <div v-else>
          {{ $t('agenda.justificar-ausencia.foraDoPrazo.mensagem') }}
        </div>
      </template>
      <template #footer>
        <div class="columns absence">
          <b-button
            v-if="dentroDoPrazo"
            class="column confirm"
            :disabled="justificarDesativado"
            :loading="isJustificando"
            @click="justificar()"
          >
            {{ $t('agenda.justificar-ausencia.titulo') }}
          </b-button>
          <b-button
            v-else
            class="column solicitar-retorno"
            @click="solicitarRetorno"
          >
            {{ $t('agenda.justificar-ausencia.foraDoPrazo.botao') }}
          </b-button>
          &nbsp;
          <b-button
            class="column voltar"
            @click="habilitarVoltar ? voltar() : fechar()"
          >
            {{ habilitarVoltar ? $t('botoes.voltar') : $t('botoes.cancelar') }}
          </b-button>
        </div>
      </template>
    </modal-template>
  </div>
</template>

<script>
import ModalTemplate from './ModalTemplate'
import AgendamentoService from '@/services/agendamento-service'
import { format } from 'date-fns'

export default {
  name: 'JustificarAusenciaModal',
  components: { ModalTemplate },
  data() {
    return {
      motivo: undefined,
      data: undefined,
      converterTeleatendimento: undefined,
      isJustificando: false,
      motivoCancelamento: '',
      monthNames: [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro'
      ],
      dayNames: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
      exibirAvisoFeriasColetivas: false
    }
  },
  props: {
    toggle: {
      type: Boolean,
      default: false
    },
    atendimentos: {
      type: Array,
      default: null
    },
    habilitarVoltar: {
      type: Boolean,
      default: false
    },
    isTeleatendimento: {
      type: Boolean,
      default: false
    },
    atendimentosRemarcar: {
      type: Array,
      default: () => []
    },
    paciente: {
      type: Object,
      default: null
    }
  },
  computed: {
    justificarDesativado() {
      return (!this.isTeleatendimento && !this.motivo) || !this.validar()
    },
    dentroDoPrazo() {
      let filterFn = (a) =>
        this.atendimentos.includes(a.Agendamento.CodigoAtendimento) &&
        a.Agendamento.PrazoLimiteRemarcacao >= 0
      let mapFn = function (a) {
        let dataLimiteRemarcacao = new Date(a.Agendamento.Data)
        dataLimiteRemarcacao.setMinutes(
          dataLimiteRemarcacao.getMinutes() -
            a.Agendamento.PrazoLimiteRemarcacao
        )
        return dataLimiteRemarcacao
      }
      let atendimentosSelecionadosComPrazo =
        this.atendimentosRemarcar.filter(filterFn)
      return (
        atendimentosSelecionadosComPrazo.length <= 0 ||
        new Date(Math.min(...atendimentosSelecionadosComPrazo.map(mapFn))) >
          new Date()
      )
    }
  },
  mounted() {
    // this.updateExibirAvisoFeriasColetivas() // Remove - Mensagem de Aviso Coletivo //
    this.updateMotivo()
  },
  methods: {
    updateExibirAvisoFeriasColetivas() {
      if (!this.paciente) {
        return
      }
      this.exibirAvisoFeriasColetivas = [17, 22].includes(
        this.paciente.CodigoUnidade
      )
    },
    updateMotivo() {
      if (this.isSoCancelavel()) {
        this.motivo = '4'
      }
    },
    toggleInfoModal() {
      this.$emit('closeModal', 'cancelar')
    },
    justificar() {
      if (this.validar() && Array.isArray(this.$props.atendimentos)) {
        this.isJustificando = true
        AgendamentoService.postRemarcarAtendimentos(
          this.$props.atendimentos,
          this.motivo,
          this.data,
          this.converterTeleatendimento,
          this.motivoCancelamento
        ).then((response) => {
          this.isJustificando = false
          if (response.status === 200) {
            this.$emit('closeModal', 'confirmado', this.motivo)
          }
        })
      }
    },
    validar() {
      if (!this.motivo) {
        return false
      }

      if (this.motivo === '4' && this.motivoCancelamento.length > 3) {
        return true
      }

      if (!this.data) {
        return false
      }

      let dataMinima = this.getDataMinima()
      let dataMinimaValida = dataMinima ? this.data > dataMinima : true
      let dataMaximaValida = this.data <= this.getDataMaxima()

      return dataMinimaValida && dataMaximaValida
    },
    voltar() {
      this.$emit('closeModal', 'voltar')
    },
    fechar() {
      this.$emit('closeModal', 'fechar')
    },
    dateFormatter(date) {
      return format(date, 'dd/MM/yyyy')
    },
    format(date) {
      return format(date, 'dd/MM/yyyy')
    },
    getDataMinima() {
      this.updateMotivo()
      if (['3'].includes(this.motivo)) {
        let filterFn = (a) =>
          this.atendimentos.includes(a.Agendamento.CodigoAtendimento)
        let mapFn = function (a) {
          return new Date(a.Agendamento.Data)
        }
        let atendimentosSelecionados =
          this.atendimentosRemarcar.filter(filterFn)
        return new Date(Math.max(...atendimentosSelecionados.map(mapFn)))
      }
      let date = new Date()
      return date.setDate(date.getDate() - 15)
    },
    getMenorData() {
      let filterFn = (a) =>
        this.atendimentos.includes(a.Agendamento.CodigoAtendimento)
      let mapFn = function (a) {
        return new Date(a.Agendamento.Data)
      }
      let atendimentosSelecionados = this.atendimentosRemarcar.filter(filterFn)
      return new Date(Math.min(...atendimentosSelecionados.map(mapFn)))
    },
    getDataMaxima() {
      this.updateMotivo()
      if (['3'].includes(this.motivo)) {
        let hoje = new Date()
        return new Date(hoje.setMonth(hoje.getMonth() + 6))
      }
      return new Date()
    },
    isAtendimentoProximo() {
      let menorData = this.getMenorData()
      let d = new Date()
      return menorData < d.setDate(d.getDate() + 15)
    },
    dateParser(dateString) {
      let dateParts = dateString.split('/')
      return new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0])
    },
    isSoCancelavel() {
      let someFn = (a) =>
        this.atendimentos.includes(a.Agendamento.CodigoAtendimento) &&
        a.Agendamento.LimiteRemarcacaoPaciente -
          a.Agendamento.QuantidadeRemarcacoesPaciente <=
          0
      return this.atendimentosRemarcar.some(someFn)
    },
    solicitarRetorno() {
      window.open('https://www.sarah.br/area-paciente/retorno/')
    }
  }
}
</script>

<style lang="scss" scoped src="@/assets/stylesheets/components/shared/modal/JustificarAusenciaModal.scss"></style>
<style src="@/assets/stylesheets/components/shared/modal/JustificarAusenciaModal-overrides.css"></style>
